setTimeout(() => {
  function getMaxQty() {
    var $el = $(".js-main-product");
    if (!$el.length) return 0;

    var val = parseInt($el.attr("total-input"), 10);
    return isNaN(val) ? 0 : val;
  }

  function sanitizeQty(val, max) {
    val = parseInt(val, 10);
    if (isNaN(val) || val < 0) val = 0;
    if (val > max) val = max;
    return val;
  }

  function getTotalUsedQty() {
    var total = 0;
    $(".js-input-val").each(function () {
      total += parseInt($(this).val(), 10) || 0;
    });
    return total;
  }

  function updateProgressAndMaxes() {
    var max = getMaxQty();
    var used = getTotalUsedQty();
    var remaining = max - used;
    if (remaining < 0) remaining = 0;

    // $(".js-left-qty").text(remaining);

    var percent = max ? (used / max) * 100 : 0;
    /****Update here */
    // $(".js-progress-bar").css("width", Math.min(percent, 100) + "%");
    
    // $(".js-counting").text(used);

    // GLOBAL TICKET ACTIVE UPDATE BASED ON TOTAL USED
    $(".js-ticket-items").each(function () {
      var index = parseInt($(this).attr("data-index"), 10);
      if (index <= used) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });

    $(".js-input-val").each(function () {
      var currentVal = parseInt($(this).val(), 10) || 0;
      var newMax = currentVal + remaining;
      $(this).attr("max", newMax);

      if (currentVal > newMax) {
        $(this).val(newMax);
      }
    });
    const qtyshs = $(".quantity-error-message");

    var maxQty = getMaxQty(); 
    var usedQty = getTotalUsedQty();

    // Quantity controls disable ONLY when limit reached
    $(".js_quantity_wrapp").toggleClass(
      "disabled",
      usedQty === maxQty && maxQty > 0
    );

    // ✅ ERROR MESSAGE — EXACT RULE
    if (usedQty === maxQty && maxQty > 0) {
      qtyshs.removeClass("hidden");
    } else {
      qtyshs.addClass("hidden");
    }
  }

  // function toggleBuyButton($context) {
  //   var qty = parseInt($context.find(".js-cart-qty").val(), 10) || 0;
  //   var max = getMaxQty();
  //   var $btn = $context.find(".product-form__submit");

  //   if (qty <= 0 || max === 0) {
  //     $btn.prop("disabled", true).addClass("disabled");
  //   } else {
  //     $btn.prop("disabled", false).removeClass("disabled");
  //   }
  // }

  function toggleBuyButton($context) {
    var qty = parseInt($context.find(".js-input-val").val(), 10) || 0;
    var max = getMaxQty();
    var $btn = $context.find(".product-form__submit");

    var spots = parseInt($btn.attr("data-spots"));
    var purchased = parseInt($btn.attr("data-purchased"));

    if (qty <= 0 || max === 0 || spots === purchased) {
      $btn.prop("disabled", true).addClass("disabled");
    } else {
      $btn.prop("disabled", false).removeClass("disabled");
    }
  }


  function updateTicketActive(qty, $context) {
    var $input = $context.find(".js-input-val");
    var currentVal = parseInt($input.val(), 10) || 0;

    var totalUsed = getTotalUsedQty() - currentVal;
    var maxForThis = getMaxQty() - totalUsed;
    if (maxForThis < 0) maxForThis = 0;

    qty = sanitizeQty(qty, maxForThis);

    $context.find(".js-input-val, .js-cart-qty").val(qty);
    /***Update Here */
    // $context.find(".js-counting").text(qty);



    var $priceEl = $context.find(".js-main-product");
    if ($priceEl.length) {
      var basePrice = parseFloat($priceEl.attr("data-price"));
      var currency = $priceEl.attr("cart-currency");

      if (!isNaN(basePrice)) {
        $context
          .find(".js-prouct-price")
          .text(currency + (basePrice * qty).toFixed(2));
      }
    }

    updateProgressAndMaxes();
    toggleBuyButton($context);
  }

  $(document).on("click", ".js-plus-qty", function () {
    var $context = $(this).closest(".js-product-col");
    var val = parseInt($context.find(".js-input-val").val(), 10) || 0;
    updateTicketActive(val + 1, $context);
    console.log('dkndsad')
  });

  $(document).on("click", ".js-minus-qty", function () {
    var $context = $(this).closest(".js-product-col");
    var val = parseInt($context.find(".js-input-val").val(), 10) || 0;
    updateTicketActive(val - 1, $context);
  });

  $(document).on("input change", ".js-input-val", function () {
    var $context = $(this).closest(".js-product-col");
    updateTicketActive($(this).val(), $context);
  });

  $(document).on("click", ".js-ticket-items", function () {
    var $context = $(this).closest(".js-product-col");
    var val = parseInt($(this).attr("ticket-number"), 10);
    updateTicketActive(val, $context);
  });

  $(document).ready(function () {
    updateProgressAndMaxes();

    $(".js-product-col").each(function () {
      toggleBuyButton($(this));
    });
  });

}, 2000);
